import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import AnimateOnScroll from './AnimateOnScroll';

export default function FAQ() {
  const { t } = useTranslation();

  const faqs = [
    { q: t('FAQ.q1'), a: t('FAQ.a1') },
    { q: t('FAQ.q2'), a: t('FAQ.a2') },
    { q: t('FAQ.q3'), a: t('FAQ.a3') },
    { q: t('FAQ.q4'), a: t('FAQ.a4') },
    { q: t('FAQ.q5'), a: t('FAQ.a5') },
    { q: t('FAQ.q6'), a: t('FAQ.a6') },
    { q: t('FAQ.q7'), a: t('FAQ.a7') },
    { q: t('FAQ.q8'), a: t('FAQ.a8') },
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <section className="py-20" style={{ background: '#f8f9fe' }} id="faq">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>

      <div className="container">
        <AnimateOnScroll>
          <div className="grid grid-cols-1 pb-8 text-center">
            <h1 className="t-h1">{t('FAQ.title')}</h1>
            <p className="text-slate-400 dark:text-slate-300 max-w-xl mx-auto">
              {t('FAQ.subtitle')}
            </p>
          </div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 gap-3 max-w-3xl mx-auto">
          {faqs.map((faq, i) => (
            <AnimateOnScroll key={i} animation="fadeUp" delay={i * 40}>
              <details className="group bg-white rounded-xl border p-5 cursor-pointer transition duration-300 hover:shadow-sm" style={{ borderColor: '#e5e7eb' }}>
                <summary className="flex items-center justify-between font-semibold list-none" style={{ color: '#010C66', fontFamily: '"Wix Madefor Display", sans-serif' }}>
                  <span>{faq.q}</span>
                  <span className="ml-4 transition-transform duration-300 group-open:rotate-45 text-xl flex-shrink-0" style={{ color: '#709CFF' }}>
                    +
                  </span>
                </summary>
                <p className="mt-3 leading-relaxed text-sm" style={{ color: '#6b7280' }}>{faq.a}</p>
              </details>
            </AnimateOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
}
